<template>
  <Loader2 class="animate-spin" />
</template>

<script lang="ts" setup>
import {Loader2} from "@lucide/vue";
</script>
